
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f1YjX", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc8696e3d2c183fd$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $8Yfbq = parcelRequire("8Yfbq");


var $cA3Tq = parcelRequire("cA3Tq");


var $l2qS4 = parcelRequire("l2qS4");


var $2uNd6 = parcelRequire("2uNd6");

var $58c26cbd87218cf2$export$2e2bcd8739ae039 = (product)=>{
    (0, $2uNd6.loadAtlassianSwitcher)();
    if (product === 'jira') return (0, $2uNd6.loadJiraSwitcher)();
    if (product === 'confluence') return (0, $2uNd6.loadConfluenceSwitcher)();
    return (0, $2uNd6.loadGenericSwitcher)();
};



var $c2TlB = parcelRequire("c2TlB");


var $iEAT5 = parcelRequire("iEAT5");

const $4d0cc6fe2704cf10$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $58c26cbd87218cf2$export$2e2bcd8739ae039)(product);
    (0, $c2TlB.prefetchFlightDeck)({});
    (0, $cA3Tq.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $iEAT5.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $l2qS4.prefetchJoinableSites)(props.joinableSitesDataProvider);
};



var $gyt00 = parcelRequire("gyt00");


var $a3xa0 = parcelRequire("a3xa0");
var $ffCOo = parcelRequire("ffCOo");
var $7TH2w = parcelRequire("7TH2w");
var $1DWH0 = parcelRequire("1DWH0");


var $03bmy = parcelRequire("03bmy");

const $fc8696e3d2c183fd$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $fc8696e3d2c183fd$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $fc8696e3d2c183fd$var$TRIGGER_CONTEXT = {
    componentName: (0, $a3xa0.TRIGGER_COMPONENT),
    ...(0, $03bmy.default)
};
class $fc8696e3d2c183fd$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick
        }, children);
    }
    constructor(...args){
        super(...args);
        this.lastEnteredAt = void 0;
        this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $a3xa0.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
        };
        this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
            (0, $4d0cc6fe2704cf10$export$aba5d6cf034db22e)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $fc8696e3d2c183fd$var$THROTTLE_EXPIRES, $fc8696e3d2c183fd$var$THROTTLE_OPTIONS);
        this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $gyt00.performanceNow)();
        };
        this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $gyt00.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $fc8696e3d2c183fd$var$PrefetchTriggerWithEvents = (0, $1DWH0.default)()($fc8696e3d2c183fd$var$PrefetchTrigger);
var $fc8696e3d2c183fd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.NavigationAnalyticsContext), {
        data: $fc8696e3d2c183fd$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fc8696e3d2c183fd$var$PrefetchTriggerWithEvents, props));

});

parcelRegister("cA3Tq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cj14x = parcelRequire("cj14x");


var $kBWmB = parcelRequire("kBWmB");


var $grirN = parcelRequire("grirN");

const $02cabd97f79fd287$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $02cabd97f79fd287$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $kBWmB.fetchJsonWithNetworkRetries)(`${$02cabd97f79fd287$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $02cabd97f79fd287$export$7fd9c7ae7afb494c = ()=>{
    return (0, $cj14x.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $grirN.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $02cabd97f79fd287$export$1096efb00c5f8afc);
};


const { fetchMethod: $d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $d506fce92bbefc59$var$DefaultBffDataProviderComponent } = (0, $02cabd97f79fd287$export$7fd9c7ae7afb494c)();
const $d506fce92bbefc59$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d506fce92bbefc59$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product
    }, children);
const $d506fce92bbefc59$export$1c5684a3ba697d80 = $d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts;
const $d506fce92bbefc59$export$cd9fc41c59711bdd = ()=>$d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts.reset();
module.exports["AvailableProductsProvider"] = $d506fce92bbefc59$export$4c169257ef988618;
module.exports["prefetchAvailableProducts"] = $d506fce92bbefc59$export$1c5684a3ba697d80;

});

parcelRegister("irYQs", function(module, exports) {
$parcel$export(module.exports, "default", () => $d479263545be1416$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $a3xa0 = parcelRequire("a3xa0");
var $7TH2w = parcelRequire("7TH2w");


var $1DWH0 = parcelRequire("1DWH0");


var $2PqoT = parcelRequire("2PqoT");


var $9Gu3R = parcelRequire("9Gu3R");


var $9N1hJ = parcelRequire("9N1hJ");

const $d479263545be1416$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $d479263545be1416$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $d479263545be1416$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $d479263545be1416$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $d479263545be1416$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $d479263545be1416$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $d479263545be1416$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $d479263545be1416$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $9Gu3R.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $2PqoT.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$d479263545be1416$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $2PqoT.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args);
            this.acceptResults = true;
            this.state = getInitialState(this.props.params);
            this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $d479263545be1416$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    DataProvider.displayName = `DataProvider(${name})`;
    const InnerComponent = (0, $1DWH0.default)()((0, $9N1hJ.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}
module.exports["Status"] = $d479263545be1416$export$96e9906d6d93a972;
module.exports["isComplete"] = $d479263545be1416$export$9569565a7ac14e8e;
module.exports["isError"] = $d479263545be1416$export$e6127cc7fe7395c3;
module.exports["isLoading"] = $d479263545be1416$export$20bb0d907fbbe433;
module.exports["hasLoaded"] = $d479263545be1416$export$5fce62f50756dbf;

});

parcelRegister("a3xa0", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("1DWH0")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("ffCOo")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("7TH2w")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("7TH2w")).UI_EVENT_TYPE);

var $42omo = parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");


var $eWRwJ = parcelRequire("eWRwJ");

var $1DWH0 = parcelRequire("1DWH0");


var $7TH2w = parcelRequire("7TH2w");


var $irYQs = parcelRequire("irYQs");


var $6jqOS = parcelRequire("6jqOS");

const $69527efa806e8e82$var$INFINITY = '+Inf';
const $69527efa806e8e82$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $69527efa806e8e82$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $69527efa806e8e82$var$INFINITY) : null;
};


const $7608769595671f03$export$515664faa1398f37 = 'navigation';
const $7608769595671f03$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $7608769595671f03$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $7608769595671f03$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $7608769595671f03$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $7608769595671f03$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $7608769595671f03$export$2b570fc112cbca = 'atlassianSwitcher';
const $7608769595671f03$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $7608769595671f03$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $7608769595671f03$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $7608769595671f03$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $7608769595671f03$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $7608769595671f03$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $7608769595671f03$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $7608769595671f03$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $7608769595671f03$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $7608769595671f03$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $7608769595671f03$var$RENDERED_ACTION = 'rendered';
const $7608769595671f03$var$NOT_RENDERED_ACTION = 'not_rendered';
const $7608769595671f03$var$VIEWED_ACTION = 'viewed';
const $7608769595671f03$export$884b1a4c7ac9dd14 = (0, $eWRwJ.default)($7608769595671f03$export$515664faa1398f37);
const $7608769595671f03$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $7608769595671f03$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
    };
};
const $7608769595671f03$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $7608769595671f03$export$e09ad93c2b74b853 = (0, $1DWH0.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            action: $7608769595671f03$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$7608769595671f03$var$isValidDuration(duration) && {
                    bucket: (0, $69527efa806e8e82$export$b59492d26971ae92)(duration, (0, $69527efa806e8e82$export$e59c24bc0768d568))
                }
            }
        }).fire($7608769595671f03$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $7608769595671f03$export$95b1f1a72cad0dcb = (0, $1DWH0.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            action: $7608769595671f03$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($7608769595671f03$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $7608769595671f03$export$b3fd6624b6a6d057 = (0, $1DWH0.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: $7608769595671f03$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($7608769595671f03$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $7608769595671f03$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7608769595671f03$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7608769595671f03$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $7608769595671f03$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7608769595671f03$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7608769595671f03$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $7608769595671f03$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $irYQs.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $7608769595671f03$var$renderTracker({
        subject: $7608769595671f03$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $7608769595671f03$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $irYQs.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $6jqOS.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $7608769595671f03$var$renderTrackerWithReason({
        subject: $7608769595671f03$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $7608769595671f03$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$7608769595671f03$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });
module.exports["NAVIGATION_CHANNEL"] = $7608769595671f03$export$515664faa1398f37;
module.exports["SWITCHER_SUBJECT"] = $7608769595671f03$export$17ff9c46e41eb585;
module.exports["SWITCHER_ITEM_SUBJECT"] = $7608769595671f03$export$7598b001981cfda5;
module.exports["SWITCHER_ITEM_LOZENGES_SUBJECT"] = $7608769595671f03$export$c3c93e13b09d3ad9;
module.exports["SWITCHER_CHILD_ITEM_SUBJECT"] = $7608769595671f03$export$7d4d527df0e3789c;
module.exports["SWITCHER_ITEM_EXPAND_SUBJECT"] = $7608769595671f03$export$16cf10618135eb24;
module.exports["SWITCHER_COMPONENT"] = $7608769595671f03$export$2b570fc112cbca;
module.exports["SWITCHER_SOURCE"] = $7608769595671f03$export$5ed36c4d23de5568;
module.exports["TRIGGER_COMPONENT"] = $7608769595671f03$export$8d2f933bbd9e4f09;
module.exports["TRIGGER_SUBJECT"] = $7608769595671f03$export$d7029a5dc66b0736;
module.exports["SWITCHER_PARTIAL_RESULTS"] = $7608769595671f03$export$4649adbfda1b6a66;
module.exports["SWITCHER_ORG_ITEM"] = $7608769595671f03$export$6dd696c9ad636a67;
module.exports["SWITCHER_ORG_LIST"] = $7608769595671f03$export$d9d2f872f3b91169;
module.exports["SWITCHER_JOINABLE_SITES"] = $7608769595671f03$export$5724539c9b1a3a5d;
module.exports["SWITCHER_AVAILABLE_PRODUCTS"] = $7608769595671f03$export$22f5f827d9934254;
module.exports["createAndFireNavigationEvent"] = $7608769595671f03$export$884b1a4c7ac9dd14;
module.exports["analyticsAttributes"] = $7608769595671f03$export$a305f130b289b818;
module.exports["withAnalyticsContextData"] = $7608769595671f03$export$97ebdd8e7274f18a;
module.exports["RenderTracker"] = $7608769595671f03$export$e09ad93c2b74b853;
module.exports["NotRenderedTracker"] = $7608769595671f03$export$95b1f1a72cad0dcb;
module.exports["ViewedTracker"] = $7608769595671f03$export$b3fd6624b6a6d057;
module.exports["getJoinableSitesRenderTracker"] = $7608769595671f03$export$e823e937102b322b;
module.exports["getCustomLinksRenderTracker"] = $7608769595671f03$export$d75a4f56d85f67ea;
module.exports["getItemAnalyticsContext"] = $7608769595671f03$export$6489efba2ca85102;

});

parcelRegister("6jqOS", function(module, exports) {
var $06a679a5cd4d19b0$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $06a679a5cd4d19b0$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.reason = void 0;
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}
module.exports["UserSiteDataErrorReason"] = $06a679a5cd4d19b0$export$b08600051ba52198;
module.exports["UserSiteDataError"] = $06a679a5cd4d19b0$export$c460344055e97b1;

});

parcelRegister("2PqoT", function(module, exports) {
function $0267a58c9e5215a2$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}
module.exports["errorToReason"] = $0267a58c9e5215a2$export$a3e288208721751b;

});

parcelRegister("9N1hJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $83ac2687fdc1a19b$var$noop = ()=>{};
const $83ac2687fdc1a19b$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $42omo.createContext)({
    start: $83ac2687fdc1a19b$var$noop,
    success: $83ac2687fdc1a19b$var$noop,
    failure: $83ac2687fdc1a19b$var$noop,
    failureAll: $83ac2687fdc1a19b$var$noop,
    abort: $83ac2687fdc1a19b$var$noop,
    abortAll: $83ac2687fdc1a19b$var$noop,
    markStart: $83ac2687fdc1a19b$var$noop,
    markEnd: $83ac2687fdc1a19b$var$noop
});
const $83ac2687fdc1a19b$export$cdefb2a8b53f879f = ()=>(0, $42omo.useContext)($83ac2687fdc1a19b$export$3f3eebb4b8116461);
const $83ac2687fdc1a19b$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $83ac2687fdc1a19b$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};
module.exports["SwitcherExperienceTrackerContext"] = $83ac2687fdc1a19b$export$3f3eebb4b8116461;
module.exports["useExperienceTracker"] = $83ac2687fdc1a19b$export$cdefb2a8b53f879f;
module.exports["withExperienceTracker"] = $83ac2687fdc1a19b$export$f88dde183f4d31cb;

});

parcelRegister("kBWmB", function(module, exports) {

var $jIyl9 = parcelRequire("jIyl9");


var $9Gu3R = parcelRequire("9Gu3R");


var $03bmy = parcelRequire("03bmy");

const $628bbc7f670a215c$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $jIyl9.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $628bbc7f670a215c$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $03bmy.default).packageVersion,
            ...init?.headers
        }
    }).then(!emptyResponse ? $628bbc7f670a215c$var$extraJsonFromResponse : ()=>{});
const $628bbc7f670a215c$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $9Gu3R.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $03bmy.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($628bbc7f670a215c$var$extraJsonFromResponse);
};
const $628bbc7f670a215c$export$c776284ef4b1209a = (url, data, emptyResponse)=>$628bbc7f670a215c$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);
module.exports["fetchJson"] = $628bbc7f670a215c$export$6d71b655afe1638d;
module.exports["fetchJsonWithNetworkRetries"] = $628bbc7f670a215c$export$16566b750080153d;
module.exports["postJson"] = $628bbc7f670a215c$export$c776284ef4b1209a;

});

parcelRegister("jIyl9", function(module, exports) {
const $c1dbd2effcc8e151$export$83179404a61b001a = 'FetchError';
class $c1dbd2effcc8e151$export$26e841bcf1aeb894 extends Error {
    static isFetchError(value) {
        return value instanceof $c1dbd2effcc8e151$export$26e841bcf1aeb894;
    }
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.name = $c1dbd2effcc8e151$export$83179404a61b001a;
        this.status = status;
    }
}
module.exports["FETCH_ERROR_NAME"] = $c1dbd2effcc8e151$export$83179404a61b001a;
module.exports["FetchError"] = $c1dbd2effcc8e151$export$26e841bcf1aeb894;

});

parcelRegister("03bmy", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc7959e6d06e21c8$export$2e2bcd8739ae039);
const $dc7959e6d06e21c8$var$packageName = "platform-pkg";
const $dc7959e6d06e21c8$var$packageVersion = "0.0.0-use.local";
var $dc7959e6d06e21c8$export$2e2bcd8739ae039 = {
    packageName: $dc7959e6d06e21c8$var$packageName,
    packageVersion: $dc7959e6d06e21c8$var$packageVersion
};

});

parcelRegister("grirN", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

function $e9039098110424ea$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}


var $8a33a59a55c04de9$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $8a33a59a55c04de9$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $8a33a59a55c04de9$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $8a33a59a55c04de9$var$allNonTestExperienceMarks = Object.values($8a33a59a55c04de9$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $8a33a59a55c04de9$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks
};
const $8a33a59a55c04de9$export$805ed806e0769ee4 = (0, $e9039098110424ea$export$c371a74fe5222b3)($8a33a59a55c04de9$export$755e75afbd377bc4);
var $8a33a59a55c04de9$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $8a33a59a55c04de9$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $8a33a59a55c04de9$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';
module.exports["Experience"] = $8a33a59a55c04de9$export$c90b54e658fc4d7c;
module.exports["EXPERIENCE_CONFIGS"] = $8a33a59a55c04de9$export$d54d7a2744fdf647;
module.exports["ExperienceMark"] = $8a33a59a55c04de9$export$cbf1e672c3e37474;
module.exports["EXPERIENCES_TO_MARKS"] = $8a33a59a55c04de9$export$755e75afbd377bc4;
module.exports["MARKS_TO_EXPERIENCES"] = $8a33a59a55c04de9$export$805ed806e0769ee4;
module.exports["ExperienceMarkPhase"] = $8a33a59a55c04de9$export$ec8391a70bbdbe59;
module.exports["AbortReason"] = $8a33a59a55c04de9$export$279d6315a97b520d;
module.exports["SWITCHER_RENDER_START_PERFORMANCE_MARK"] = $8a33a59a55c04de9$export$86919b84f9a64054;

});

parcelRegister("l2qS4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $emHKt = parcelRequire("emHKt");

const { fetchMethod: $19041cad7a2e4757$var$fetchJoinableSites, ProviderComponent: $19041cad7a2e4757$var$DefaultDataProviderComponent } = (0, $emHKt.createJoinableSitesProvider)();
const $19041cad7a2e4757$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $19041cad7a2e4757$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DataProviderComponent, {
        cloudId: cloudId
    }, children);
};
const $19041cad7a2e4757$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $19041cad7a2e4757$var$fetchJoinableSites({});
};
const $19041cad7a2e4757$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $19041cad7a2e4757$var$fetchJoinableSites.reset();
};
module.exports["JoinableSitesProvider"] = $19041cad7a2e4757$export$70da68d3b04f82d0;
module.exports["prefetchJoinableSites"] = $19041cad7a2e4757$export$2aed3ef1595b4d9;

});

parcelRegister("emHKt", function(module, exports) {

var $cj14x = parcelRequire("cj14x");


var $grirN = parcelRequire("grirN");

const $e2ed5e516e933600$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $e2ed5e516e933600$export$c3b6af53f1ca17d8 = (fetchData = $e2ed5e516e933600$export$62986affcccd56a5, retryConfig)=>{
    return (0, $cj14x.createProviderWithCustomFetchData)('joinableSites', (0, $grirN.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};
module.exports["createJoinableSitesProvider"] = $e2ed5e516e933600$export$c3b6af53f1ca17d8;

});

parcelRegister("2uNd6", function(module, exports) {

var $4wH3g = parcelRequire("4wH3g");


var $42omo = parcelRequire("42omo");


var $hRQgD = parcelRequire("hRQgD");


const $43492e8623899440$export$6c6894dd831bfacb = ()=>(parcelRequire("koI7V")).then((module)=>module.default);

const $43492e8623899440$export$52c59c5b477673fb = ()=>(parcelRequire("gnMUL")).then((module)=>module.default);

const $43492e8623899440$export$2d2945898d9ee55f = ()=>(parcelRequire("9soZb")).then((module)=>module.default);

const $43492e8623899440$export$64191a36345a6b2b = ()=>(parcelRequire("hwx4k")).then((module)=>module.default);
const $43492e8623899440$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "SZcx1",
    name: "AtlassianSwitcherLoader",
    loader: $43492e8623899440$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hRQgD.default), null)
});
const $43492e8623899440$export$10767845f9f42bd = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "HbcUy",
    name: "JiraSwitcherLoader",
    loader: $43492e8623899440$export$52c59c5b477673fb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hRQgD.default), null)
});
const $43492e8623899440$export$71f961c620294b68 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "IdoNX",
    name: "ConfluenceSwitcherLoader",
    loader: $43492e8623899440$export$2d2945898d9ee55f,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hRQgD.default), null)
});
const $43492e8623899440$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "xoErk",
    name: "GenericSwitcherLoader",
    loader: $43492e8623899440$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hRQgD.default), null)
});
module.exports["loadAtlassianSwitcher"] = $43492e8623899440$export$6c6894dd831bfacb;
module.exports["loadJiraSwitcher"] = $43492e8623899440$export$52c59c5b477673fb;
module.exports["loadConfluenceSwitcher"] = $43492e8623899440$export$2d2945898d9ee55f;
module.exports["loadGenericSwitcher"] = $43492e8623899440$export$64191a36345a6b2b;
module.exports["AtlassianSwitcherLoader"] = $43492e8623899440$export$25f16f9fee84a840;
module.exports["JiraSwitcherLoader"] = $43492e8623899440$export$10767845f9f42bd;
module.exports["ConfluenceSwitcherLoader"] = $43492e8623899440$export$71f961c620294b68;
module.exports["GenericSwitcherLoader"] = $43492e8623899440$export$8c21d1a0c59fc17e;

});

parcelRegister("hRQgD", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a02204e74f72794$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $grirN = parcelRequire("grirN");

var $88ga6 = parcelRequire("88ga6");


var $8C5kA = parcelRequire("8C5kA");


var $d3Dtl = parcelRequire("d3Dtl");

const $6a02204e74f72794$var$iconSkeleton = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $6a02204e74f72794$var$lineSkeleton = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $6a02204e74f72794$export$2e2bcd8739ae039 = ()=>{
    (0, $88ga6.useExperienceRenderAndMountMark)((0, $grirN.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const items = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        }
    }, $6a02204e74f72794$var$iconSkeleton, $6a02204e74f72794$var$lineSkeleton);
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $d3Dtl.default).skeletonLoaderAriaLabel),
        testId: "skeleton"
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        "aria-hidden": "true",
        style: {
            paddingInline: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-300, 24px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }
    }, $6a02204e74f72794$var$lineSkeleton), items, items, items);
};

});

parcelRegister("88ga6", function(module, exports) {
/* eslint-disable no-console */ 
var $9N1hJ = parcelRequire("9N1hJ");


var $42omo = parcelRequire("42omo");


var $dIWel = parcelRequire("dIWel");

function $bebaa2c4a150a593$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $9N1hJ.useExperienceTracker)();
    (0, $dIWel.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $bebaa2c4a150a593$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $9N1hJ.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $42omo.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $bebaa2c4a150a593$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $9N1hJ.useExperienceTracker)();
    (0, $dIWel.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $42omo.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}
module.exports["useExperienceSuccess"] = $bebaa2c4a150a593$export$e94f0da4fc0603c6;
module.exports["useExperienceRenderAndMountMark"] = $bebaa2c4a150a593$export$fb30551804b67d63;

});

parcelRegister("dIWel", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d2d6ce3394020471$export$abf4268d2dd55708(builder) {
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $d2d6ce3394020471$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $42omo.useRef)(false);
    const result = (0, $42omo.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}
module.exports["useSingleton"] = $d2d6ce3394020471$export$abf4268d2dd55708;
module.exports["useOnceImmediately"] = $d2d6ce3394020471$export$ad4f8d0eee7a0e24;

});

parcelRegister("d3Dtl", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $baba7124b42cf074$var$messages = (0, $cgtv4.defineMessages)({
    newLozenge: {
        id: "fabric.atlassianSwitcher.newLozenge",
        defaultMessage: "New"
    },
    tryLozenge: {
        id: "fabric.atlassianSwitcher.tryLozenge",
        defaultMessage: "Try"
    },
    sites: {
        id: "fabric.atlassianSwitcher.sites",
        defaultMessage: "{productName} {numSites, plural, one {site} other {sites}}"
    },
    skeletonLoaderAriaLabel: {
        id: "fabric.atlassianSwitcher.skeletonLoaderAriaLabel",
        defaultMessage: "The App Switcher is loading"
    },
    skeleton3pLoaderAriaLabel: {
        id: "fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel",
        defaultMessage: "The App Switcher third party section is loading"
    },
    reorderItemDropdown: {
        id: "fabric.atlassianSwitcher.reorderItemDropdown",
        defaultMessage: "Reorder menu item"
    },
    moveItemUp: {
        id: "fabric.atlassianSwitcher.moveItemUp",
        defaultMessage: "Move up"
    },
    moveItemDown: {
        id: "fabric.atlassianSwitcher.moveItemDown",
        defaultMessage: "Move down"
    },
    moveItemToTop: {
        id: "fabric.atlassianSwitcher.moveItemToTop",
        defaultMessage: "Move to top"
    },
    moveItemToBottom: {
        id: "fabric.atlassianSwitcher.moveItemToBottom",
        defaultMessage: "Move to bottom"
    }
});
var $baba7124b42cf074$export$2e2bcd8739ae039 = $baba7124b42cf074$var$messages;
module.exports["default"] = $baba7124b42cf074$export$2e2bcd8739ae039;

});

parcelRegister("koI7V", function(module, exports) {

let $ed9847344f5fea15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ed9847344f5fea15$var$load("bL3as"),
    $ed9847344f5fea15$var$load("l9Zim"),
    $ed9847344f5fea15$var$load("6XyGC")
]).then(()=>parcelRequire('cV69w'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("gnMUL", function(module, exports) {

let $bed4bcc0fa0b8532$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bed4bcc0fa0b8532$var$load("jSdjl"),
    $bed4bcc0fa0b8532$var$load("l2EUC"),
    $bed4bcc0fa0b8532$var$load("joFPh"),
    $bed4bcc0fa0b8532$var$load("6wr18"),
    $bed4bcc0fa0b8532$var$load("bL3as"),
    $bed4bcc0fa0b8532$var$load("l9Zim"),
    $bed4bcc0fa0b8532$var$load("gxkWc"),
    $bed4bcc0fa0b8532$var$load("lUQAm"),
    $bed4bcc0fa0b8532$var$load("8JZKd"),
    $bed4bcc0fa0b8532$var$load("io1wi"),
    $bed4bcc0fa0b8532$var$load("dTsOE"),
    $bed4bcc0fa0b8532$var$load("hhss7"),
    $bed4bcc0fa0b8532$var$load("ffEVr"),
    $bed4bcc0fa0b8532$var$load("awqCy"),
    $bed4bcc0fa0b8532$var$load("a3B2V")
]).then(()=>parcelRequire('38oWY'));

});

parcelRegister("9soZb", function(module, exports) {

let $6e2a1c41a9b534c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6e2a1c41a9b534c5$var$load("jSdjl"),
    $6e2a1c41a9b534c5$var$load("l2EUC"),
    $6e2a1c41a9b534c5$var$load("joFPh"),
    $6e2a1c41a9b534c5$var$load("6wr18"),
    $6e2a1c41a9b534c5$var$load("bL3as"),
    $6e2a1c41a9b534c5$var$load("l9Zim"),
    $6e2a1c41a9b534c5$var$load("gxkWc"),
    $6e2a1c41a9b534c5$var$load("lUQAm"),
    $6e2a1c41a9b534c5$var$load("8JZKd"),
    $6e2a1c41a9b534c5$var$load("io1wi"),
    $6e2a1c41a9b534c5$var$load("dTsOE"),
    $6e2a1c41a9b534c5$var$load("hhss7"),
    $6e2a1c41a9b534c5$var$load("ffEVr"),
    $6e2a1c41a9b534c5$var$load("awqCy"),
    $6e2a1c41a9b534c5$var$load("9B1r0")
]).then(()=>parcelRequire('ebk01'));

});

parcelRegister("hwx4k", function(module, exports) {

let $cc1f1397e99fdade$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc1f1397e99fdade$var$load("jSdjl"),
    $cc1f1397e99fdade$var$load("l2EUC"),
    $cc1f1397e99fdade$var$load("joFPh"),
    $cc1f1397e99fdade$var$load("6wr18"),
    $cc1f1397e99fdade$var$load("bL3as"),
    $cc1f1397e99fdade$var$load("l9Zim"),
    $cc1f1397e99fdade$var$load("gxkWc"),
    $cc1f1397e99fdade$var$load("lUQAm"),
    $cc1f1397e99fdade$var$load("8JZKd"),
    $cc1f1397e99fdade$var$load("io1wi"),
    $cc1f1397e99fdade$var$load("dTsOE"),
    $cc1f1397e99fdade$var$load("hhss7"),
    $cc1f1397e99fdade$var$load("ffEVr"),
    $cc1f1397e99fdade$var$load("awqCy"),
    $cc1f1397e99fdade$var$load("kgItH")
]).then(()=>parcelRequire('gfMaa'));

});

parcelRegister("c2TlB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");


var $cj14x = parcelRequire("cj14x");


var $grirN = parcelRequire("grirN");


var $2GCGk = parcelRequire("2GCGk");


var $lzcvT = parcelRequire("lzcvT");


var $alOHm = parcelRequire("alOHm");


var $kaECR = parcelRequire("kaECR");

const $6382434be202e562$var$client = new (0, $g58eM.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $6382434be202e562$var$fetchFlightDeck, ProviderComponent: $6382434be202e562$var$DefaultFlightDeckProviderComponent } = (0, $cj14x.createProviderWithCustomFetchData)('flightDeck', (0, $grirN.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $6382434be202e562$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $6382434be202e562$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $6382434be202e562$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $2GCGk.formatLabel)(displayName),
            rebrandedLabel: rebrandedDisplayName && (0, $2GCGk.formatLabel)(rebrandedDisplayName),
            description: (0, $2GCGk.formatDescription)(subtitle),
            iconKey: iconKey,
            rebrandedIconKey: rebrandedIconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $alOHm.ASSETS_APP_KEY))) artifactMap.set((0, $alOHm.ASSETS_APP_KEY), {
            key: (0, $alOHm.ASSETS_APP_KEY),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            label: (0, $2GCGk.formatLabel)((0, $kaECR.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $2GCGk.formatLabel)(link.displayName),
                    description: (0, $2GCGk.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $6382434be202e562$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6382434be202e562$var$DefaultFlightDeckProviderComponent, null, children);
const $6382434be202e562$export$7d2a567d3e50224 = $6382434be202e562$var$fetchFlightDeck;
module.exports["FlightDeckProvider"] = $6382434be202e562$export$56da85ac9d40dbcd;
module.exports["prefetchFlightDeck"] = $6382434be202e562$export$7d2a567d3e50224;

});

parcelRegister("2GCGk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

const $ea0d4fd6a5dec6f1$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), label);
};
const $ea0d4fd6a5dec6f1$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), description) : null;
};
module.exports["formatLabel"] = $ea0d4fd6a5dec6f1$export$957d7daebd899f12;
module.exports["formatDescription"] = $ea0d4fd6a5dec6f1$export$f731e929548061dc;

});

parcelRegister("alOHm", function(module, exports) {
const $f990887179ccebd8$export$45e63649edff1e2a = 'ASSETS';
const $f990887179ccebd8$export$eb7589a4ee50c678 = 'tenantless';
module.exports["ASSETS_APP_KEY"] = $f990887179ccebd8$export$45e63649edff1e2a;
module.exports["TENANTLESS_ORG_ID"] = $f990887179ccebd8$export$eb7589a4ee50c678;

});

parcelRegister("kaECR", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $952538c0e85b84fa$var$messages = (0, $cgtv4.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.title",
        defaultMessage: "Get started with cloud"
    },
    emptyStateExploreProductsBody: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body",
        defaultMessage: "Try a product to start collaborating with your team."
    },
    emptyStateExploreProductsLink: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link",
        defaultMessage: "Explore products"
    },
    home: {
        id: "fabric.atlassianSwitcher.atlassianHome",
        defaultMessage: "Home"
    },
    administration: {
        id: "fabric.atlassianSwitcher.administration",
        defaultMessage: "Administration"
    },
    atlassianStart: {
        id: "fabric.atlassianSwitcher.start",
        defaultMessage: "Atlassian Start"
    },
    assets: {
        id: "fabric.atlassianSwitcher.assets",
        defaultMessage: "Assets"
    },
    analytics: {
        id: "fabric.atlassianSwitcher.analytics",
        defaultMessage: "Analytics"
    },
    companyHub: {
        id: "fabric.atlassianSwitcher.companyHub",
        defaultMessage: "Company Hub"
    },
    goals: {
        id: "fabric.atlassianSwitcher.goals",
        defaultMessage: "Goals"
    },
    projects: {
        id: "fabric.atlassianSwitcher.projects",
        defaultMessage: "Projects"
    },
    teams: {
        id: "fabric.atlassianSwitcher.teams",
        defaultMessage: "Teams"
    },
    search: {
        id: "fabric.atlassianSwitcher.search",
        defaultMessage: "Search"
    },
    chat: {
        id: "fabric.atlassianSwitcher.chat",
        defaultMessage: "Chat"
    },
    studio: {
        id: "fabric.atlassianSwitcher.studio",
        defaultMessage: "Studio"
    },
    manageList: {
        id: "fabric.atlassianSwitcher.manageList",
        defaultMessage: "Manage list"
    },
    errorEmptyPartialResults: {
        id: "fabric.atlassianSwitcher.errorEmptyPartialResults",
        defaultMessage: "We can't display your apps right now."
    },
    errorHeading: {
        id: "fabric.atlassianSwitcher.errorHeading",
        defaultMessage: "Something\u2019s gone wrong"
    },
    errorText: {
        id: "fabric.atlassianSwitcher.errorText",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things"
    },
    errorImageAltText: {
        id: "fabric.atlassianSwitcher.errorImageAltText",
        defaultMessage: "A broken robot and a number of people busy fixing it."
    },
    errorTextNetwork: {
        id: "fabric.atlassianSwitcher.errorTextNetwork",
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again."
    },
    errorHeadingLoggedOut: {
        id: "fabric.atlassianSwitcher.errorHeadingLoggedOut",
        defaultMessage: "Your Atlassian account is logged out"
    },
    errorHeadingUnverified: {
        id: "fabric.atlassianSwitcher.errorHeadingUnverified",
        defaultMessage: "Your account is unverified"
    },
    errorPartialResults: {
        id: "fabric.atlassianSwitcher.errorPartialResults",
        defaultMessage: "We can't display some of your apps right now."
    },
    errorPartialResultsRefresh: {
        id: "fabric.atlassianSwitcher.errorPartialResultsRefresh",
        defaultMessage: "Refresh the page, or try again later."
    },
    errorTextUnverified: {
        id: "fabric.atlassianSwitcher.errorTextUnverified",
        defaultMessage: "Please confirm your email address to view a list of available products."
    },
    productDescriptionConfluence: {
        id: "fabric.atlassianSwitcher.product.description.confluence",
        defaultMessage: "Document collaboration"
    },
    productDescriptionJiraServiceManagement: {
        id: "fabric.atlassianSwitcher.product.description.jsm",
        defaultMessage: "Collaborative IT service management"
    },
    productDescriptionJiraSoftware: {
        id: "fabric.atlassianSwitcher.product.description.jsw",
        defaultMessage: "Project and issue tracking"
    },
    productDescriptionOpsgenie: {
        id: "fabric.atlassianSwitcher.product.description.opsgenie",
        defaultMessage: "Modern incident management"
    },
    productDescriptionCompass: {
        id: "fabric.atlassianSwitcher.product.description.compass",
        defaultMessage: "Component manager"
    },
    join: {
        id: "fabric.atlassianSwitcher.join",
        defaultMessage: "Join"
    },
    expandProductList: {
        id: "fabric.atlassianSwitcher.expandProductList",
        defaultMessage: "{numItems} more"
    },
    collapseProductList: {
        id: "fabric.atlassianSwitcher.contractProductList",
        defaultMessage: "Less"
    },
    emptyStateExploreProductsBodyAppify: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify",
        defaultMessage: "Try an app to start collaborating with your team."
    },
    emptyStateExploreProductsLinkAppify: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify",
        defaultMessage: "Explore apps"
    },
    errorTextUnverifiedAppify: {
        id: "fabric.atlassianSwitcher.errorTextUnverified-appify",
        defaultMessage: "Please confirm your email address to view a list of available apps."
    }
});
var $952538c0e85b84fa$export$2e2bcd8739ae039 = $952538c0e85b84fa$var$messages;
module.exports["default"] = $952538c0e85b84fa$export$2e2bcd8739ae039;

});

parcelRegister("iEAT5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cj14x = parcelRequire("cj14x");


var $kBWmB = parcelRequire("kBWmB");


var $grirN = parcelRequire("grirN");

const $155c4b8a491e7969$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $155c4b8a491e7969$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $kBWmB.fetchJsonWithNetworkRetries)(`${$155c4b8a491e7969$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $155c4b8a491e7969$export$1a41882ddb3a9c38 = ()=>{
    return (0, $cj14x.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $grirN.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $155c4b8a491e7969$export$c39ca0fbc2221bcc);
};


const { fetchMethod: $d21fa97e199ffdc1$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $d21fa97e199ffdc1$var$DefaultBffThirdPartyProductsDataProvider } = (0, $155c4b8a491e7969$export$1a41882ddb3a9c38)();
const $d21fa97e199ffdc1$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d21fa97e199ffdc1$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product
    }, children);
const $d21fa97e199ffdc1$export$ba83558707df5bbe = $d21fa97e199ffdc1$var$fetchAppSwitcherBffThirdPartyProducts;
const $d21fa97e199ffdc1$export$fdb5fe543e39bc7a = ()=>$d21fa97e199ffdc1$var$fetchAppSwitcherBffThirdPartyProducts.reset();
module.exports["ThirdPartyProductsProvider"] = $d21fa97e199ffdc1$export$a7ffda257898c103;
module.exports["prefetchThirdPartyProducts"] = $d21fa97e199ffdc1$export$ba83558707df5bbe;

});

parcelRegister("gyt00", function(module, exports) {
const $54b2b65df874895b$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;
module.exports["performanceNow"] = $54b2b65df874895b$export$fb4230f160368c88;

});

parcelRegister("dq4RI", function(module, exports) {

var $grirN = parcelRequire("grirN");

function $61b5f86e72d687e1$export$3ac4e94b194cd647(experience) {
    return (0, $grirN.EXPERIENCES_TO_MARKS)[experience].map($61b5f86e72d687e1$var$generateUFOTiming);
}
function $61b5f86e72d687e1$var$generateUFOTiming(mark) {
    return {
        key: mark,
        startMark: $61b5f86e72d687e1$export$504463c8409cf4d7(mark, (0, $grirN.ExperienceMarkPhase).START),
        endMark: $61b5f86e72d687e1$export$504463c8409cf4d7(mark, (0, $grirN.ExperienceMarkPhase).END)
    };
}
const $61b5f86e72d687e1$export$504463c8409cf4d7 = (mark, phase)=>`${mark}_${phase}`;
const $61b5f86e72d687e1$export$16539b434cec5cfb = ()=>{
    performance.mark((0, $grirN.SWITCHER_RENDER_START_PERFORMANCE_MARK));
};
const $61b5f86e72d687e1$export$436b7aeb93937572 = ()=>{
    const renderStartPerformanceMarks = performance.getEntriesByName ? performance.getEntriesByName((0, $grirN.SWITCHER_RENDER_START_PERFORMANCE_MARK)) : [];
    return renderStartPerformanceMarks[renderStartPerformanceMarks.length - 1]?.startTime;
};
module.exports["experienceTimingsOf"] = $61b5f86e72d687e1$export$3ac4e94b194cd647;
module.exports["generateUFOMarkName"] = $61b5f86e72d687e1$export$504463c8409cf4d7;
module.exports["setSwitcherRenderStartMark"] = $61b5f86e72d687e1$export$16539b434cec5cfb;
module.exports["getSwitcherRenderStartMark"] = $61b5f86e72d687e1$export$436b7aeb93937572;

});

parcelRegister("9Gu3R", function(module, exports) {
const $21671ff65c1374e7$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $21671ff65c1374e7$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $21671ff65c1374e7$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};
module.exports["retryOnException"] = $21671ff65c1374e7$export$1d94629c94e7a17f;

});

parcelRegister("cj14x", function(module, exports) {

var $irYQs = parcelRequire("irYQs");


var $kBWmB = parcelRequire("kBWmB");


var $bgtNw = parcelRequire("bgtNw");

const $0acabe6f2babf099$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $bgtNw.withCached)((param)=>(0, $kBWmB.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $irYQs.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $0acabe6f2babf099$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $bgtNw.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $irYQs.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};
module.exports["createProviderWithCustomFetchData"] = $0acabe6f2babf099$export$310e48be95687c2f;

});

parcelRegister("bgtNw", function(module, exports) {
const $952e82f27780b933$export$d4d4b402ab64e2f4 = 5000;
const $952e82f27780b933$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $952e82f27780b933$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($952e82f27780b933$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $952e82f27780b933$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};
module.exports["withCached"] = $952e82f27780b933$export$7f51828d6b6af163;

});


//# sourceMappingURL=PageLayout.a861b02f.js.map
